// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"326":"component---src-components-templates-people-jsx","523":"cb1608f2"}[chunkId] + "-" + {"326":"afd35306f7b27651cb96","523":"ed0defbbf6f5ffb3ed8b"}[chunkId] + ".js";
};